import _ from 'lodash';
import React from 'react';
import { InputContainer } from '../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';

export const LogisticsBasicInfoComponent = ({ selectLogisticsConfigurations, logisticsOrderType, handleInnerFormChange }: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Used For Retail"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event,
                                    'LogisticsmConfigurations.IsUsedForRetail',
                                    selectLogisticsConfigurations?.LogisticsmConfigurations,
                                );
                            }}
                            type="checkbox"
                            value={selectLogisticsConfigurations?.LogisticsmConfigurations?.IsUsedForRetail}
                        />
                        <InputContainer
                            label="Order Type"
                            labelField="Description"
                            list={logisticsOrderType}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'LogisticsmConfigurations.LogisticsOrderType',
                                    selectLogisticsConfigurations?.LogisticsmConfigurations,

                                );
                            }}
                            optionName='Choose OrderType'
                            type="select"
                            value={selectLogisticsConfigurations?.LogisticsmConfigurations?.LogisticsOrderType}
                            valueField="Description"
                        />


                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="BasicInfo"
            />
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                        <InputContainer
                            label="Online Order"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event,
                                    'ParcelPaymentMethod.IsOnlineOrder',
                                    selectLogisticsConfigurations?.ParcelPaymentMethod,
                                );
                            }}
                            type="checkbox"
                            value={selectLogisticsConfigurations?.ParcelPaymentMethod?.IsOnlineOrder}
                        />
                        <InputContainer
                            label="COD Order"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event,
                                    'ParcelPaymentMethod.IsCODOrder',
                                    selectLogisticsConfigurations?.ParcelPaymentMethod,
                                );
                            }}
                            type="checkbox"
                            value={selectLogisticsConfigurations?.ParcelPaymentMethod?.IsCODOrder}
                        />

                    </div>
                }
                expandedPanel="ParcelPaymentMethodInfo"
                headerTitle="Parcel Info"
            />
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                        <InputContainer
                            label="Online Order"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event,
                                    'CargoPaymentMethod.IsOnlineOrder',
                                    selectLogisticsConfigurations?.CargoPaymentMethod,
                                );
                            }}
                            type="checkbox"
                            value={selectLogisticsConfigurations?.CargoPaymentMethod?.IsOnlineOrder}
                        />
                        <InputContainer
                            label="COD Order"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event,
                                    'CargoPaymentMethod.IsCODOrder',
                                    selectLogisticsConfigurations?.CargoPaymentMethod,
                                );
                            }}
                            type="checkbox"
                            value={selectLogisticsConfigurations?.CargoPaymentMethod?.IsCODOrder}
                        />

                    </div>
                }
                expandedPanel="CargoPaymentMethod"
                headerTitle="Cargo Info"
            />
        </>
    )
}
export default LogisticsBasicInfoComponent;
